import { Box, styled, Typography } from '@mui/material'

export const Wrapper = styled(Box, {
  shouldForwardProp: (prop) =>
    prop !== 'backgroundColor' && prop !== 'hoverEnabled',
})<{ backgroundColor: string; hoverEnabled?: boolean }>`
  min-height: 88px;
  background-color: ${({ backgroundColor }) => backgroundColor};
  display: flex;
  align-items: stretch;
  padding: 8px;
  gap: 16px;
  width: 100%;

  ${({ hoverEnabled, theme }) =>
    hoverEnabled &&
    `
    cursor: pointer;

    &:hover {
      background-color: ${theme.palette.custom.gray6};
    }
  `};
`

export const ImageWrapper = styled(Box)`
  flex-shrink: 0;
  width: 72px;
  height: 72px;
`

export const Image = styled('img')`
  width: 100%;
  height: 100%;
  object-fit: cover;
`

export const Information = styled(Box)`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`

export const InformationTopWrapper = styled(Box)`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  min-height: 0;
  overflow: hidden;
`

export const InformationBottomWrapper = styled(Box)`
  flex-shrink: 0;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 8px;
  min-width: 0;
`

export const ProductName = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'unavailable',
})<{ unavailable?: boolean }>`
  margin-top: 6px;
  font-size: 14px;
  font-weight: 500;
  line-height: 16px;
  color: ${({ theme, unavailable }) =>
    unavailable ? '#EA4968' : theme.palette.custom.blue1};
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
`

export const ProductCode = styled(Typography)`
  font-size: 13px;
  font-weight: 400;
  color: ${({ theme }) => theme.palette.custom.gray2};
  line-height: 15px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const ProductPricePerUnit = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'color' && prop !== 'clickable',
})<{ color: string; clickable?: boolean }>`
  font-size: 13px;
  font-weight: 400;
  color: ${({ color }) => color};
  line-height: 15px;
  white-space: nowrap;
  flex-shrink: 0;
  ${({ clickable }) =>
    clickable &&
    `
    cursor: pointer;
    border-bottom: 1px dashed #000;
    padding-bottom: 2px;
  `};
`

export const ProductErpCatalog = styled(Typography)`
  font-size: 13px;
  font-weight: 400;
  color: ${({ theme }) => theme.palette.custom.gray2};
  line-height: 15px;
  margin-top: 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const ProductCodeWrapper = styled(Box)`
  min-width: 0;
  overflow: hidden;
`
